<template>
    <div class="h-full w-full flex flex-col p-8">
        <form @submit.prevent="submitForm">
            <div v-for="(item, index) in uploadDocuments" :key="index" class="flex justify-start items-center mb-4">
                <div class="mr-2">{{ index + 1 }}.</div>


                <!-- <input :ref="`document-file-${index}`" class="hidden" :id="`document-file-${index}`" :key="`document-file-${index}`" @change="handleFileChange" type="file" accept="application/pdf,image/*">
                <div class="flex items-center">
                    <div @click.stop="onPickFile(`document-file-${index}`)" class="rounded-lg h-10 border border-ternary bg-white hover:bg-ternary text-ternary hover:text-white px-6 text-sm uppercase cursor-pointer flex items-center justify-center">Upload</div>
                    <div class="ml-2 flex items-center cursor-pointer group" v-if="item.val">
                        <icon-document class="h-4 w-4 flex-shrink-0"></icon-document>
                        <div class="ml-0.5 leading-tight text-xs">{{ item.val.name }}</div>
                    </div>
                </div> -->

                <input :id="`document-file-${index}`" :key="`document-file-${index}`" type="file" @change="handleFileChange" accept="application/pdf,image/*" />

                <div v-if="hasUploadDocuments" class="flex-grow flex justify-end items-center">
                    <button type="button" @click="removeFile(index)">
                        <icon-close class="h-6 w-6 text-red-600"></icon-close>
                    </button>
                </div>
            </div>
            <div class="w-full flex justify-center mt-6">
                <div @click.stop="addFile" :class="isFormInvalid ? 'cursor-not-allowed' : 'cursor-pointer'" class="flex items-center bg-white border border-ternary hover:bg-ternary px-4 py-2 rounded-lg cursor-pointer text-ternary hover:text-white">
                    <icon-plus class="w-4 h-4"></icon-plus>
                    <span class="text-xs ml-2">Add more</span>
                </div>
            </div>
            <div class="w-full flex justify-end mt-6">
                <button type="submit" :class="isFormInvalid ? 'cursor-not-allowed' : 'cursor-pointer'" class="flex items-center bg-ternary border border-ternary hover:bg-white px-4 py-2 rounded-lg text-white hover:text-ternary" :disabled="isFormInvalid">Submit</button>
            </div>
        </form>
    </div>
</template>

<script>
import IconPlus from "../../../components/icons/IconPlus.vue";
import IconClose from "../../../components/icons/IconClose.vue";
// import IconDocument from "../../../components/icons/IconDocument.vue";
export default {
    name: "upload-documents",
    emits: ["document-submit"],
    components: {
        IconPlus,
        IconClose,
        // IconDocument,
    },
    data() {
        return {
        uploadDocuments: [
                {
                    val: null,
                    isValid: true,
                    msg: "",
                },
            ],
            uploadDocumentIndex: 0,
        };
    },
    computed: {
        hasUploadDocuments () {
            if (this.uploadDocuments.length > 1) {
                return true;
            } else {
                return false;
            }
        },
        isFormInvalid() {
            // Disable the submit button if there are null files
            return this.uploadDocuments.some((file) => file.val === null);
        },
    },
    methods: {
        onPickFile(ref) {
            console.log(ref);
            this.$refs[ref].click();
        },
        handleFileChange(event) {

            this.uploadDocuments[this.uploadDocumentIndex].isValid = true;
            this.uploadDocuments[this.uploadDocumentIndex].msg = "";
            const file = event.target.files[0];

            if (file) {
                if (file.type !== 'application/pdf' && !file.type.includes('image/')) {
                    this.uploadDocuments[this.uploadDocumentIndex].isValid = false;
                    this.uploadDocuments[this.uploadDocumentIndex].msg = 'Only JPG, JPEG, PNG and PDF files are allowed.';
                } else if (file.size > 2 * 1024 * 1024) {
                    this.uploadDocuments[this.uploadDocumentIndex].isValid = false;
                    this.uploadDocuments[this.uploadDocumentIndex].msg = 'File size must be less than 2MB.';
                } else {
                    this.uploadDocuments[this.uploadDocumentIndex].isValid = true;
                    this.uploadDocuments[this.uploadDocumentIndex].msg = '';
                    this.uploadDocuments[this.uploadDocumentIndex].val = file;
                }
            }

        },
        addFile() {
            if (this.uploadDocuments.some((file) => file.val === null)) {
                console.log('no file');
            } else {
                this.uploadDocuments.push(
                    {
                        val: null,
                        isValid: true,
                        msg: "",
                    }
                );
                this.uploadDocumentIndex += 1;
            }
        },
        removeFile(index) {
            this.uploadDocuments.splice(index, 1);
            this.uploadDocumentIndex -= 1;
        },
        submitForm() {
            const validFiles = this.uploadDocuments
                .map((file) => file.val)
                .filter((file) => file !== null);

            this.$emit('document-submit', validFiles);
        },
    },
};
</script>